export const MODE_DESCRIPTIONS = {
  personal: {
    title: "Personal Mode",
    description: "Best for individual users. Manage your own documents and spreadsheets privately with full control—no sharing, no approvals, just simple personal management."
  },
  business: {
    title: "Business Mode",
    description: "Designed for teams and businesses. Collaborate with multiple team members using role-based access, approvals, and controlled sharing. Upgrade from Personal Mode to unlock collaboration features."
  },
  enterprise: {
    title: "Enterprise Mode",
    description: "Built for large organizations managing multiple businesses. Connect multiple teams and businesses under super admins with advanced control and scalability (features under expansion)."
  }
};